<template>
  <div class="main">
    <div class="container">
      <h2 class="form-title">登录</h2>
      <el-form :model="loginForm" :rules="rules" ref="loginForm" label-width="80px">
        <el-form-item label="手机号" prop="userPhone">
          <el-input
            v-model="loginForm.userPhone"
            placeholder="请输入手机号"
            maxlength="11"
            show-word-limit
            prefix-icon="el-icon-mobile-phone"
            @keyup.enter.native="submit"
          ></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            v-model="loginForm.password"
            type="password"
            placeholder="请输入密码"
            maxlength="20"
            show-password
            prefix-icon="el-icon-lock"
            @keyup.enter.native="submit"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <div class="form-options">
            <el-checkbox v-model="loginForm.rememberMe">记住我</el-checkbox>
            <el-link type="primary" :underline="false" @click="forgotPassword">忘记密码？</el-link>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="submit-btn" :loading="loading" @click="submit" style="width: 100%;">
            {{ loading ? '登录中...' : '登录' }}
          </el-button>
        </el-form-item>
        <div class="form-footer">
          <span>还没有账号？</span>
          <el-link type="primary" :underline="false" @click="goToSignUp">立即注册</el-link>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号'));
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号'));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入密码'));
      } else if (value.length < 6 || value.length > 20) {
        callback(new Error('密码长度为 6-20 位'));
      } else {
        callback();
      }
    };
    return {
      loginForm: {
        userPhone: '',
        password: '',
        rememberMe: false
      },
      rules: {
        userPhone: [
          { validator: validatePhone, trigger: 'blur' }
        ],
        password: [
          { validator: validatePassword, trigger: 'blur' }
        ]
      },
      loading: false,
      redirect: this.$route.query.redirect
    };
  },
  created() {
    if (localStorage.getItem('rememberedPhone')) {
      this.loginForm.userPhone = localStorage.getItem('rememberedPhone');
      this.loginForm.rememberMe = true;
    }
  },
  methods: {
    submit() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$axios({
            method: 'post',
            url: '/user/login',
            data: {
              userPhone: this.loginForm.userPhone,
              password: this.loginForm.password
            }
          }).then((res) => {
            this.loading = false;
            if (res.code == "200") {
              if (this.loginForm.rememberMe) {
                localStorage.setItem('rememberedPhone', this.loginForm.userPhone);
              } else {
                localStorage.removeItem('rememberedPhone');
              }
              localStorage.setItem("loginResult", JSON.stringify(res.data));
              this.$store.commit("login", res.data);
              document.cookie = `server-token=${res.data.token}; path=/; max-age=${this.loginForm.rememberMe ? 2592000 : 7200}`;
              document.cookie = `userId=${res.data.userId}; path=/; max-age=${this.loginForm.rememberMe ? 2592000 : 7200}`;
              this.$message.success({
                message: '登录成功',
                duration: 2000
              });
              this.$router.push({ path: this.redirect || '/' });
            } else {
              this.$message.error({
                message: res.msg || '登录失败',
                duration: 3000
              });
            }
          }).catch((error) => {
            this.loading = false;
            console.log(error);
            this.$message.error({
              message: '登录失败，请稍后重试',
              duration: 3000
            });
          });
        } else {
          return false;
        }
      });
    },
    forgotPassword() {
      this.$message.info('请联系管理员重置密码');
    },
    goToSignUp() {
      this.$router.push({ name: 'SignUp' });
    }
  }
};
</script>
<style lang="less" scoped>
.main {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;

  .container {
    width: 100%;
    max-width: 450px;
    background: #fff;
    padding: 40px;
    border-radius: 10px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);

    .form-title {
      margin: 0 0 30px;
      text-align: center;
      font-size: 28px;
      font-weight: 600;
      color: #333;
    }

    .form-options {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .submit-btn {
      height: 45px;
      font-size: 16px;
      font-weight: 500;
      letter-spacing: 1px;
    }

    .form-footer {
      text-align: center;
      margin-top: 20px;
      color: #666;
      font-size: 14px;

      span {
        margin-right: 8px;
      }
    }
  }
}

::v-deep .el-form-item__label {
  font-weight: 500;
  color: #555;
}

::v-deep .el-input__inner {
  height: 45px;
  border-radius: 5px;
}

::v-deep .el-form-item {
  margin-bottom: 22px;
}

::v-deep .el-checkbox__label {
  color: #666;
}

::v-deep .el-link.el-link--primary {
  font-size: 14px;
}
</style>